import type { TFunction } from 'i18next'

export function formatBuildingFloorLocation(
  t: TFunction,
  buildingName?: string | null,
  floorName?: string | null,
  fallback = '',
) {
  return (
    [
      buildingName ? t('common.buildingLocation', { name: buildingName }) : '',
      floorName ? t('common.floorLocation', { name: floorName }) : '',
    ]
      .filter(Boolean)
      .join(' / ') || fallback
  )
}
